"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsertCopyLink = void 0;
const clipboard_1 = require("@/app/shared/helpers/clipboard");
const wrapper_1 = require("@/app/shared/pages/wrapper");
const actions_1 = require("@/wrapper/actions");
async function InsertCopyLink(payload, dialogRef) {
    const htmlToAdd = wrapper_1.CopyLinkWidgetRenderer.renderHTML(payload);
    await (0, actions_1.setBodyHTML)(htmlToAdd);
    await (0, clipboard_1.copyToClipboard)(payload.shortLink);
    if (dialogRef.current)
        dialogRef.current.close();
}
exports.InsertCopyLink = InsertCopyLink;
